/**
 * Get previous query from the store
 * @param qPrevID - Stored ID of the previous query
 * @returns {string | undefined}
 */
export function getPrevQuery(store, qPrevID) {
    return qPrevID && store.getQueryByID(qPrevID);
}
/**
 * Get the ID of a previous query that is stored for a connection
 * @param r {object} - Connection
 * @returns {string | undefined}
 */
export function getPrevQueryID(store, r) {
    const storedQueryForConnection = store.getQueryForConnection(r);
    return storedQueryForConnection && store.getQueryID(storedQueryForConnection);
}
//# sourceMappingURL=queryGetters.js.map